module.exports = __webpack_public_path__ + "static/img/zanting.a488963b.png";